import $ from 'jquery'

export const $DOM = {
	$window: $(window),
    $body: $('body'),
    $header: $('.header'),
}